import { Phone, Mail, MapPin, Clock, Receipt } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-20 md:py-28 bg-[#F8FAFC] border-t border-gray-200/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-start">
          <div>
            <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-gray-500">
              Get in touch
            </span>
            <h2 className="mt-2 text-3xl sm:text-4xl font-bold font-heading tracking-tight text-[#0F2D52]">
              Speak to a Money Mart advisor
            </h2>
            <p className="mt-3 text-sm text-gray-600 leading-relaxed max-w-md">
              Prefer a direct conversation? Reach us during business hours — our advisory team will be happy to guide you.
            </p>

            <div className="mt-8 space-y-4">
              <ContactRow icon={<Phone />} label="Phone" value={CONTACT.phone} href={`tel:+${CONTACT.phoneDigits}`} testId="contact-phone" />
              <ContactRow icon={<Mail />} label="Email" value={CONTACT.email} href={`mailto:${CONTACT.email}`} testId="contact-email" />
              <ContactRow icon={<MapPin />} label="Office" value={CONTACT.address} testId="contact-address" />
              <ContactRow icon={<Clock />} label="Business Hours" value={CONTACT.hours} testId="contact-hours" />
              <ContactRow icon={<Receipt />} label="GST" value={CONTACT.gst} testId="contact-gst" />
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden border border-gray-200 bg-white shadow-[0_12px_32px_rgba(15,45,82,0.08)]">
            <iframe
              title="Money Mart Office Location"
              src={CONTACT.mapEmbed}
              width="100%"
              height="460"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon, label, value, href, testId }) {
  const Wrap = href ? "a" : "div";
  return (
    <Wrap
      href={href}
      data-testid={testId}
      className={`flex items-start gap-3 group ${href ? "hover:text-[#0F2D52] mm-transition" : ""}`}
    >
      <div className="w-10 h-10 rounded-xl bg-white border border-gray-200 flex items-center justify-center text-[#1E5AA8] shrink-0">
        {icon}
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.14em] font-bold text-gray-500">
          {label}
        </div>
        <div className="text-sm text-gray-800 font-medium">{value}</div>
      </div>
    </Wrap>
  );
}
